import React from 'react';
import Footer from '../Footer/Footer';
import styles from './AfterLoginLayout.module.scss';
import { useLocation } from 'react-router-dom';

export interface IAfterLoginLayoutProps {
  children: React.ReactNode;
}

const AfterLoginLayout: React.FC<IAfterLoginLayoutProps> = ({ children }) => {
  const location = useLocation();
  const isPlanSelection = location.pathname === '/plan-selection';

  return (
    <div className={styles.pageContainer}>
      <div className={styles.main}>{children}</div>

      {!isPlanSelection && (
        <div className={styles.footerWrapper}>
          <div className={styles.footer}>
            <Footer />
          </div>
        </div>
      )}
    </div>
  );
};

export default AfterLoginLayout;
